import { useEffect, useState } from "react";
import "../styles/Coberturas.css";
import CoberturasCards from "./CoberturasCards";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { ButtonNextMobile, ButtonPreviousMobile } from "../../../../assets/icons/Icons";

const Coberturas = ({ coberturas, coberturasDesc }) => {
  const [cobertura, setCobertura] = useState();

  const responsive = {
    320: {
      items: 1,
    },
    576: {
      items: 1,
    },
    768: {
      items: 2,
      itemsFit: "contain",
    },
    1024: {
      items: 2,
      itemsFit: "contain",
    },
    1200: {
      items: 3,
      itemsFit: "contain",
    },
    1400: {
      items: 3,
      itemsFit: "contain",
    },
    1600: {
      items: 3,
      itemsFit: "contain",
    },
    1800: {
      items: 3,
      itemsFit: "contain",
    },
  };

  useEffect(() => {
    if (coberturas?.length < 1 || coberturas === undefined) return;
    let arregloCobertura = [];
    coberturas?.forEach((element) => {
      let arregloDescripcionesCobertura = [];
      coberturasDesc?.forEach((desc) => {
        if (desc.idCobertura === element.id) {
          arregloDescripcionesCobertura.push(desc);
        }
      });
      arregloCobertura.push(
        <CoberturasCards
          cobertura={element}
          coberturasDesc={arregloDescripcionesCobertura}
        />
      );
    });
    setCobertura(arregloCobertura);
  }, [coberturas, coberturasDesc]);

  return (
    <>
      <div id="coberturas">
        <div
          className="homeout__coberturas container mt-lg-5 pt-lg-5"
          style={{ paddingBottom: "3rem" }}
        >
          <h2 style={{ color: "var(--rojo)", marginTop: "2rem", padding: "0 5%" }}>
            ¿Cómo te protege tu seguro?
          </h2>
          <p style={{ paddingBottom: "2.5rem", fontSize: "2rem", marginTop: '3rem' }}>
          Haz clic en “Conoce más” para consultar los detalles de cada una de las coberturas
          </p>

          <div className="div__carousel__coberturas">
            {cobertura?.length > 0 && (
              <AliceCarousel
                items={cobertura}
                responsive={responsive}
                centerMode={true}
                disableDotsControls
                renderPrevButton={({ isDisabled }) => {
                  return (
                    <>
                      {!isDisabled && (
                        <div className="btn__prev__coberturas">
                          <ButtonPreviousMobile />
                        </div>
                      )}
                    </>
                  );
                }}
                renderNextButton={({ isDisabled }) => {
                  return (
                    <>
                      {!isDisabled && (
                        <div className="btn__next__coberturas">
                          <ButtonNextMobile />
                        </div>
                      )}
                    </>
                  );
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Coberturas;
